import type { OneJogConfig } from '../types';
import type { PurchaseEvent } from '../types';

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

/** Envía evento de compra a Google Analytics (GA4) si está configurado */
export function sendPurchaseToGA(config: OneJogConfig, event: PurchaseEvent): void {
  if (!config.gaMeasurementId || typeof window === 'undefined' || !window.gtag) return;

  try {
    window.gtag('event', 'purchase', {
      transaction_id: event.transaction_id,
      value: event.value,
      currency: event.currency,
      items: event.items.map((item) => ({
        item_id: item.item_id,
        item_name: item.item_name,
        price: item.price,
        quantity: item.quantity,
      })),
    });
  } catch (e) {
    console.warn('[Kenbun] GA purchase event error:', e);
  }
}

/** Carga el script de gtag si el cliente pasó gaMeasurementId (opcional) */
export function loadGA(config: OneJogConfig): void {
  if (!config.gaMeasurementId || typeof document === 'undefined') return;
  if (document.querySelector('script[src*="googletagmanager.com"]')) return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${config.gaMeasurementId}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer?.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', config.gaMeasurementId);
}
